const grid = {
  rowOutsidePadding: 0,
  maxContentWidth: 1680,
  wrapperOuterMargin: {
    LRG: 80,
    MED: 48,
    SML: 24,
  },
  maxWrapperWidth: 1120,
  rowTopMargin: 48,
  maxGridWidth: { LRG: 1680, MED: 1680 }, // maxWrapperWidth + 2 * wrapperOuterMargin
  gridCols: {
    large: 12,
    medium: 12,
    small: 4,
  },
  gridColsGap: {
    SML: 24,
    MED: 24,
    LRG: 32,
  },
  gridColsFullWidth: {
    large: 1,
    medium: 1,
    small: 1,
  },
  desktopNavBP: 1072,
};

export default grid;
